import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/lib/legal-content";

export const Route = createFileRoute("/refund")({
  component: RefundPage,
  head: () => ({
    meta: [
      { title: "Refund Policy — CoderLity" },
      { name: "description", content: "CoderLity's refund policy for services, hosting, domains and software subscriptions." },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/refund" }],
  }),
});

function RefundPage() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Refund Policy"
      sub="Clear, fair rules for refunds across every product line."
      updated="May 1, 2026"
      sections={[
        { heading: "Hosting & cloud", body: "Eligible for a full refund within 14 days of first purchase if you have not exceeded fair usage. Renewals are non-refundable." },
        { heading: "Domains", body: "Domain registrations and transfers are non-refundable once submitted to the registry." },
        { heading: "Software subscriptions", body: "Monthly plans are non-refundable. Annual plans may be pro-rated within the first 30 days." },
        { heading: "Custom projects", body: "Milestone-based — completed milestones are non-refundable. Unstarted milestones can be refunded in full." },
        { heading: "How to request", body: "Email billing@coderlity.com with your order ID and reason. We respond within 2 business days." },
      ]}
    />
  );
}
